import React, { useEffect, useState } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import "../../i18n"; // important to import
function AISuggestFutureTrainingTopics() {
    const { t } = useTranslation("SuggestFutureTrainingTopics");
    const [answer, setAnswer] = useState("");
    const [checkBox, setCheckBox] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const onSubmitAnswer = async () => {
        try {
            if (!answer.trim()) {
                toast.error(t("answer_required"));
                return;
            }
            navigate("/free-trail/share-your-feedback", {
                state: {
                    step: true,
                    trailId: location.state.trailId,
                    name: location.state.name,
                    userData: location.state.userData,
                },
            });
        } catch (error) {
            // console.log(error);
        }
    };

    useEffect(() => {
        if (!location?.state?.step || !location?.state?.trailId) {
            navigate("/trail-list");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Header />
            <section className="py-5 training_topics">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="card border-0 question_card_box">
                                <div className="card-body">
                                    <h3>{t("topic_training")}</h3>
                                    <img src="/login/woman-home.webp" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 ps-xl-5 question_card_details mt-4 mt-md-5 mt-xl-0">
                            <h3> {t("next_steps")}</h3>
                            <p>{t("suggest_future_topic")}</p>

                            <textarea
                                rows="10"
                                className="form-control pt-2 mt-3 ai-textarea"
                                placeholder={t("provideAnswerHere")}
                                id="floatingTextarea2"
                                value={answer}
                                onChange={(e) => setAnswer(e.target.value)}
                            />

                            <h5> {t("reminder")}</h5>
                            <div className="manage-family-checkbox training_topics_checkbox">
                                <div class="form-check mt-3">
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        value=""
                                        id="flexCheckChecked2"
                                        name="username"
                                        checked={checkBox}
                                        onChange={(e) =>
                                            setCheckBox(e.target.checked)
                                        }
                                    />
                                    <label
                                        class="form-check-label"
                                        htmlFor="flexCheckChecked2"
                                    >
                                        {t("notify_on_availability")}
                                    </label>
                                </div>
                            </div>

                            <div className="d-flex justify-content-end pt-4 pb-md-5">
                                <button
                                    onClick={onSubmitAnswer}
                                    className="btn-explore p-sm-15 d-flex justify-content-between align-items-center gap-3 rounded-2 mt-md-4"
                                >
                                    {t("proceed")}
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={22}
                                        height={14}
                                        viewBox="0 0 22 14"
                                        fill="none"
                                        className="ms-5"
                                    >
                                        <path
                                            d="M1 6.99854H21L16 1"
                                            stroke="white"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M21 6.99805L16 12.9995"
                                            stroke="white"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}

export default AISuggestFutureTrainingTopics;
